import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    combineClasses,
} from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Toggle.scss';

function Toggle(props) {
    const {
        buttonClass,
        checked = false,
        className,
        classes: classesProp = {},
        component: ComponentProp = 'label',
        componentProps,
        disabled = false,
        indeterminate = false,
        labelComponent,
        leftLabel = false,
        onChange = () => undefined,
        value,
        variant = 'default',
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    return (
        <ComponentProp
            className={clsx(
                classes.root,
                {
                    [classes.toggle]: variant === 'slider',
                    [classes.label]: variant === 'checkbox',
                    [classes.labelDisabled]: variant === 'checkbox' && disabled,
                },
                className,
            )}
            {...componentProps}
        >
            {leftLabel && labelComponent}
            <input
                checked={checked}
                className={clsx(
                    {
                        [classes.radioButtonInput]: variant === 'default',
                        [classes[`${variant}Input`]]: variant !== 'default',
                    },
                )}
                disabled={disabled}
                onChange={onChange}
                type={variant === 'default'
                    ? 'radio'
                    : 'checkbox'}
                value={value}
                {...otherProps}
            />
            <span
                className={clsx(
                    {
                        [classes.radioButton]: variant === 'default',
                        [classes[variant]]: variant !== 'default',
                        [classes[`${variant}Checked`]]: variant === 'checkbox' && checked,
                        [classes[`${variant}Indeterminate`]]: variant === 'checkbox' && indeterminate,
                        [classes[`${variant}Disabled`]]: variant === 'checkbox' && disabled,
                    },
                    buttonClass,
                )}
            />
            {!leftLabel && labelComponent}
        </ComponentProp>
    );
}

Toggle.propTypes = {
    buttonClass: PropTypes.string,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * The component used for the root node.
     * Either a string to use a HTML element or a component.
     */
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    /**
     * The label that accompanies the radio button
     */
    labelComponent: PropTypes.node,
    /**
     * The value of the label associated with the radio button
     */
    value: PropTypes.string,
    /**
     * Function that gets called when the radio button is un/checked
     */
    onChange: PropTypes.func,
    /**
     * State of the radio button
     */
    checked: PropTypes.bool,
    /**
     * Determines the position of the label component
     */
    leftLabel: PropTypes.bool,
    /**
     * Determines whether the radio button can be toggled or not
     */
    disabled: PropTypes.bool,
    /**
     * State of the checkbox, usually used for nested checkboxes
     */
    indeterminate: PropTypes.bool,
    /**
     * Used to control the text styling.
     */
    variant: PropTypes.oneOf(['slider', 'checkbox', 'default']),
};

export default Toggle;
